module.exports = __webpack_public_path__ + "static/media/bell-start.16adcf7d.mp3";